import React from 'react'

export default props => (
    <tbody style={props.style}>
		{props.children}
	</tbody>
)
